import { FiEdit2, FiEye, FiTrash2 } from "react-icons/fi";
import Can from "../auth/Can";

/**
 * Standard view / edit / delete action buttons for data tables.
 */
export default function TableRowActions({
  readPermission,
  updatePermission,
  deletePermission,
  onView,
  onEdit,
  onDelete,
  viewLabel = "View",
  editLabel = "Edit",
  deleteLabel = "Delete",
}) {
  return (
    <div className="ui-action-group">
      <Can permission={readPermission}>
        <button
          type="button"
          className="ui-action-icon-btn ui-action-icon-view"
          onClick={onView}
          title={viewLabel}
          aria-label={viewLabel}
        >
          <FiEye aria-hidden />
        </button>
      </Can>
      <Can permission={updatePermission}>
        <button
          type="button"
          className="ui-action-icon-btn ui-action-icon-edit"
          onClick={onEdit}
          title={editLabel}
          aria-label={editLabel}
        >
          <FiEdit2 aria-hidden />
        </button>
      </Can>
      <Can permission={deletePermission}>
        <button
          type="button"
          className="ui-action-icon-btn ui-action-icon-delete"
          onClick={onDelete}
          title={deleteLabel}
          aria-label={deleteLabel}
        >
          <FiTrash2 aria-hidden />
        </button>
      </Can>
    </div>
  );
}

export function useTableActionVisibility(perms) {
  const showActions = perms.canRead || perms.canUpdate || perms.canDelete;
  return { showActions, tableColCount: showActions ? undefined : 0 };
}
